import * as apifetch from './fetch.js';

export async function getPaymentProviders() {
    const urlEndpoint = '/payment/process/getGateways.php';
    return apifetch.sbFetch(urlEndpoint, 'GET');
}

export async function getPaymentIssuers() {
    const urlEndpoint = '/payment/process/getIssuers.php';
    return apifetch.sbFetch(urlEndpoint, 'GET');
}

export async function handlePaymentProcess(order_id, order_guid, payment_data, payment_method, payment_issuer) {
    const validOrderId = Number(order_id);
    if (!Number.isSafeInteger(validOrderId) || validOrderId <= 0 || !order_guid) {
        throw new Error('A valid order id and guid are required');
    }

    const urlEndpoint = '/payment/process/processPayment.php';

    const postData = {
        order_id: validOrderId,
        order_guid,
        payment_data,
        payment_method,
        payment_issuer
    };

    try {
        const json = await apifetch.authFetch(urlEndpoint, 'POST', postData);
        if (json?.data?.redirect_url) {
            window.location.assign(json.data.redirect_url);
            return;
        }
        return json;
    } catch (error) {
        console.log('SbC fetch error payment process: ', error.message);
        throw error;
    }
}

export async function handleBankTransfer(order_id, payment_data) {
    const validOrderId = Number(order_id);
    if (!Number.isSafeInteger(validOrderId) || validOrderId <= 0) {
        throw new Error('A valid order id is required');
    }

    const urlEndpoint = '/v2/process/banktransfer/' + validOrderId;

    const postData = {
        order_id: validOrderId,
        payment_data: payment_data
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function getOrderPaymentDetails(order_id) {
    const urlEndpoint = '/payment/process/getOrderPaymentDetails.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 2000 });
}

export async function getOrderStatus(guid) {
    const urlEndpoint = '/payment/process/getOrderStatus.php';

    const postData = {
        guid: guid
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

export async function getPaymentStatus(orderId) {
    const validOrderId = Number(orderId);
    if (!Number.isSafeInteger(validOrderId) || validOrderId <= 0) {
        return { data: [] };
    }

    const urlEndpoint = '/payment/process/getPaymentStatus.php';

    const postData = {
        orderId: validOrderId
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}
